import React, {useEffect, useState} from 'react';
import './controls.scss';
import {Col, Row} from 'react-bootstrap';
import SectionHeader from './sectionHeader/SeactionHeader';
import {
  getAllMeasures
} from '../../services/measuresService/measuresApi';
import {t} from 'react-switch-lang';
import OpenIcon from '../Measures/img/Arrow.svg';
import {useUserContext} from '../../contexts/UserContext';
import {useDepartmentContext} from '../../contexts/DepartmentContext';
import {ReactComponent as PlusImg} from '../Measures/img/WhitePlus.svg';
import {Spin} from 'antd';
import {getCourtRiskId} from '../../services/getRisk';
import ControlsFormAdd from "../../components/controlsForm/ControlsFormAdd";
import ControlsFormShow from "../../components/controlsForm/ControlsFormShow";
import {getRiskControl} from "../../services/IncurredEvent/incurredEventApi";

const Controls = ({defaultData,
  allowNewControl,
  userInChargeRisk,
  responsiblePersonRisk,
  id,
  tab,
  estimatedGrossLost
}) => {

  const queryString = require('query-string');
  const parsed = queryString.parse(window.location.search);
  const urlCheck = window.location.pathname;
  let activeMeasure = 0; 
  const [open, setOpen] = useState(activeMeasure);
  const user = useUserContext();
  const departments = useDepartmentContext();
  const [meausresData, setMeasuresData] = useState([]);
  const [addNew, setAddNew] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const toggle = (event) => {
    if (parseInt(event?.target?.id) === open) {
      setOpen('');
    } else if (parseInt(event?.target?.id) !== open) {
      setOpen('');
      setOpen(parseInt(event?.target?.id));
    }
  };

  const [testId, setTestId] = useState(id);
  // let testId = id;
  const fetchData = async () => {
    try {
      let {data} = await getRiskControl(id);
      setMeasuresData(
        data.content.sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))
      );
      for (let i = 0; i < data.content.length; i++) {
        if(parsed.measure === data.content[i].id.toString()) {
          activeMeasure = i;
          setOpen(activeMeasure);
        }
      }
      setIsLoading(false);
    } catch (err) {
      if (err) {
      }
    }
  };

  const toggleAdd = () => {
    setAddNew(!addNew);
  };

  useEffect(() => {
    if (addNew === true) {
      setOpen('');
    } else {
      setOpen(activeMeasure);
    }
  }, [addNew]);

  useEffect(() => {
    if(urlCheck.toString().includes('court-risk') && window.location.search.toString().includes('tab=measures')) {
      getCourtRiskId(id).then((r) => {
        setTestId(r.data.risk.id);
        getAllMeasures(r.data.risk.id).then((r) => {
          setMeasuresData(
            r.data.sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))
          );
          for (let i = 0; i < r.data.length; i++) {
            if(parsed.measure === r.data[i].id.toString()) {
              activeMeasure = i;
              setOpen(activeMeasure);
            }
          }
          setIsLoading(false);
        });
      });
    } else {
      fetchData();
    }
  }, []);
  return (
    <>
      {isLoading ? (
        <Spin spinning={isLoading} size={'large'} className="spinner" />
      ) : (
        <div style={{width: '100%'}}>
          {( allowNewControl && (
            <Row className={`px-5 mt-3 py-3 right-btns`}>
              <Col lg={12} className="btns-float-right">
                <button
                  type="button"
                  className="primary-btn mr-2 float-right"
                  onClick={() => toggleAdd()}
                >
                  <PlusImg />
                  <span className="ml-2">{t('buttons.addNewControl')}</span>
                </button>
              </Col>
            </Row>
          ))}

          {addNew && (
            <>
              <Row className={`px-5 mt-3 py-3`}>
                <div className={`w-100 measure-section-container open`}>
                  <div className="section-header  justify-content-between align-items-center">
                    <div className="hover-effect  align-items-center">
                      <div className="section-icon">
                        <img src={OpenIcon} className={`open`} alt="Icon" />
                      </div>
                    </div>
                  </div>
                  <div className={`w-100 section-content open`}>
                    <div className="measure-form">
                  <ControlsFormAdd
                        userData={user}
                        toggleOpen={toggleAdd}
                        riskTitle={defaultData.title}
                        open={true}
                        departmentData={departments}
                        id={id}
                        tab={tab}
                      />
                    </div>
                  </div>
                </div>
              </Row>
            </>
          )}
          {meausresData.length > 0 ? (
            meausresData.map((item, idx) => {
              return (
                <Row className={`px-5 mt-3 py-3`} key={idx}>
                  <div
                    className={`w-100 measure-section-container ${
                      open === idx && 'open'
                    }`}
                  >
                    <SectionHeader
                      data={item}
                      open={open === idx ? true : false}
                      toggleOpen={(event) => toggle(event)}
                      key={idx}
                      value={idx}
                    />
                    <div
                      className={`section-content ${open === idx && 'open'}`}
                    >
                      <div className="measure-form">
                        <ControlsFormShow
                          data={item}
                          open={open === idx ? true : false}
                          toggleOpen={(event) => toggle(event)}
                          key={idx}
                          userData={user}
                          userResponsibleRisk={responsiblePersonRisk}
                          userInCharge={userInChargeRisk}
                          value={idx}
                          risk={defaultData}
                          riskTitle={defaultData.title}
                          riskId={id}
                          departmentData={departments}
                          allowEdit={allowNewControl}
                        />
                      </div>
                    </div>
                  </div>
                </Row>
              );
            })
          ) : (
              <div className="no-measures">{t('common.noControls')} </div>
          )}
        </div>
      )}
    </>
  );
};

export default Controls;
